import { Col, Pagination, Row, Table } from "antd";
import React from "react";
import { TABLE_ROWS_COUNT } from "../../constants";

type Props = {
  rowKey?: string;
  loading: boolean;
  dataSource: any[];
  columns: any[];
  maxWidth?: string;
  tableWidth?:any;
  defaultPage: number;
  currentPage: number;
  totalRows: number;
  rowSelection?: any;
  onChange?: any;
  onPageChange: (e: any) => void;
  pagination?: boolean;
};

const DataTableComponent: React.FC<Props> = ({
  rowKey,
  pagination,
  loading,
  dataSource,
  columns,
  maxWidth = "100%",
  tableWidth= null,
  defaultPage,
  totalRows,
  onPageChange,
  currentPage,
  rowSelection,
  onChange,
}: Props) => {
  return (
    <>
      <div className="mx-6">
      <div style={{ overflowX: 'auto', maxWidth }}>
        <Table
          className="app-table"
          // tableLayout="auto"
          pagination={false}
          loading={loading}
          scroll={tableWidth?{x:tableWidth}: {}}
          rowKey={rowKey}
          dataSource={dataSource}
          columns={columns}
          rowSelection={rowSelection}
          onChange={onChange}
          size="small"
        />
        {pagination && (
          <Row justify="end">
            <Col className="bg-primary-white-bluish pt-3 pb-3 pr-6">
              <Pagination
                showTotal={(total: any, range: any) =>
                  total > 0 ? `${range[0]}-${range[1]} of ${total} Total` : ""
                }
                responsive={true}
                showSizeChanger={false}
                defaultCurrent={defaultPage ? defaultPage : currentPage}
                current={currentPage}
                total={totalRows}
                defaultPageSize={TABLE_ROWS_COUNT}
                onChange={onPageChange}
              />
            </Col>
          </Row>
        )}
      </div></div>
    </>
  );
};

export default DataTableComponent;
